import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';

/**
 * @component LoadingButton
 */
function LoadingButton({
  loading,
  variant = 'contained',
  disabled,
  children,
  color,
  className,
  size = 'medium',
  ...rest
}) {
  return (
    <Button
      disabled={disabled || loading}
      variant={variant}
      color={color}
      className={className}
      size={size}
      {...rest}
    >
      {loading ? <CircularProgress size={24} color="inherit" /> : children}
    </Button>
  );
}

export default LoadingButton;
